import { SvgIcon, SvgIconProps } from "@mui/material";

const HexIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 52 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.10634 42.763L0.726601 28.5007C0.251003 27.6912 0 26.7671 0 25.8256V21.8582C0 20.874 0.274268 19.9097 0.791373 19.0758L9.84891 4.46983C10.2627 3.80254 10.82 3.23817 11.4794 2.81873L14.6456 0.804624C15.472 0.278924 16.4285 0 17.4049 0H34.9832C35.9596 0 36.9161 0.278923 37.7425 0.804624L40.8697 2.79396C41.554 3.22928 42.1281 3.82045 42.5459 4.52021L51.2544 19.1033C51.7422 19.9202 52 20.8563 52 21.8106V25.7765C52 26.749 51.7322 27.7022 51.2267 28.5295L42.4085 42.9608C42.0792 43.4998 41.6559 43.9739 41.1592 44.3601L37.8742 46.9141C36.9686 47.6182 35.8582 48 34.7157 48H17.4914C16.4609 48 15.4538 47.6893 14.5988 47.1077L10.6683 44.4338C10.0317 44.0007 9.49821 43.43 9.10634 42.763Z"
      fill="#0058DD"
    ></path>
  </SvgIcon>
);
export default HexIcon;
